import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { Main, Filter } from 'Containers/';
import { errorToast, successToast } from 'Common/ToastHelper';

import { ProductionRecordTable } from './components/ProductionRecordTable';
import * as ManageProductionSelectors from './state/manageproduction/selectors';
import * as ManageProductionActions from './state/manageproduction/actions';

class ManageProduction extends Component {
  get mainProps() {
    return {
      toolbox: {
        shown: false,
      },
      shouldNotUsePageWidth: true,
    };
  }

  componentDidUpdate(prevProps) {
    const { clearError, setCloseProductionSuccessful, setReopenProductionSuccessful } = this.props;

    errorToast(this.props, prevProps, 'error', clearError);

    successToast(
      this.props,
      prevProps,
      'closeProdRecordSuccessful',
      'Closed Successfully',
      () => setCloseProductionSuccessful(null)
    );

    successToast(
      this.props,
      prevProps,
      'reopenProdRecordSuccessful',
      'Reopened Successfully',
      () => setReopenProductionSuccessful(null)
    );
  }

  componentWillUnmount() {
    const { clearState } = this.props;

    clearState();
  }

  render() {
    const { isReadOnly } = this.props;
    return (
      <Fragment>
        <Filter title="Manage Production"></Filter>
        <Main {...this.mainProps}>
          <ProductionRecordTable isReadOnly={isReadOnly} />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: ManageProductionSelectors.getError(state),
    closeProdRecordSuccessful: ManageProductionSelectors.getCloseProdRecordSuccessful(
      state
    ),
    reopenProdRecordSuccessful: ManageProductionSelectors.getReopenProdRecordSuccessful(
      state
    ),
  };
};

const mapDispatchToProps = {
  clearError: ManageProductionActions.clearError,
  clearState: ManageProductionActions.clearState,
  setCloseProductionSuccessful: ManageProductionActions.setCloseProductionSuccessful,
  setReopenProductionSuccessful: ManageProductionActions.setReopenProductionSuccessful,
};

ManageProduction = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageProduction);

export { ManageProduction };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/ManageProduction.js